import { render, staticRenderFns } from "./PrepTaskDetail.vue?vue&type=template&id=12df7662"
import script from "./PrepTaskDetail.vue?vue&type=script&lang=js"
export * from "./PrepTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports